import { render, staticRenderFns } from "./Edit-Payment.vue?vue&type=template&id=b8791c4e&scoped=true"
import script from "./Edit-Payment.vue?vue&type=script&lang=js"
export * from "./Edit-Payment.vue?vue&type=script&lang=js"
import style0 from "./Edit-Payment.vue?vue&type=style&index=0&id=b8791c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8791c4e",
  null
  
)

export default component.exports